import Result from "../components/Result";
function ResultPage() {
  return <Result></Result>;
}
export default ResultPage;
